import { BaseDto } from "../base.dto"
import { FileDto } from "../file.dto"

export class MallPublicDto {
  id?: string
  name?: string
  slug?: string
  description?: string
  address?: string
  logo?: FileDto
  image?: FileDto
  latitude?: number
  longitude?: number
  paywayMallId?: string
  createdAt?: string
  updatedAt?: string

  static create(data: Partial<MallPublicDto>): MallPublicDto {
    return Object.assign(new MallPublicDto(), data)
  }
} 